import { render, staticRenderFns } from "./announcement-category.vue?vue&type=template&id=0b4a7c69&scoped=true"
import script from "./announcement-category.vue?vue&type=script&lang=js"
export * from "./announcement-category.vue?vue&type=script&lang=js"
import style0 from "./announcement-category.vue?vue&type=style&index=0&id=0b4a7c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a7c69",
  null
  
)

export default component.exports